import { formatReg, isPlaceholderReg } from '@aroo/shared';

export type PlateSize = 'inline' | 'xs' | 'sm' | 'md' | 'lg';

/**
 * Rendered heights in px: `inline` sits in running text without opening up the line, xs in a
 * table row, lg heads a vehicle page.
 */
export const PLATE_SIZES: Record<PlateSize, number> = {
  inline: 17,
  xs: 20,
  sm: 28,
  md: 44,
  lg: 72,
};

/** Worth drawing as a plate: letters and digits, plate-length, not a placeholder. */
export function isPlateValue(reg: string | null | undefined): boolean {
  if (!reg || isPlaceholderReg(reg)) return false;
  const n = formatReg(reg).replace(/ /g, '');
  return n.length >= 2 && n.length <= 8 && /\d/.test(n) && /[A-Z]/.test(n);
}
